import React, { useEffect, useState } from "react";

const API_BASE = "https://api.hfadigitalcreations.com";

const MentorRequests = () => {
  const [mentorRequests, setMentorRequests] = useState([]);
  const [filteredMentorRequests, setFilteredMentorRequests] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingId, setLoadingId] = useState(null);

  // Fetch mentor requests
  useEffect(() => {
    fetchMentorRequests();
  }, []);

  const fetchMentorRequests = async () => {
    try {
      const res = await fetch(`${API_BASE}/booksession/all`);
      const data = await res.json();

      console.log("Mentor API Data:", data); // Debug response

      if (data.status) {
        setMentorRequests(data.data);
        setFilteredMentorRequests(data.data);
      }
    } catch (err) {
      console.error("Error fetching mentor requests:", err);
    }
  };

  // Approve
  const approveMentorRequest = async (req) => {
    setLoadingId(req.id);
    try {
      const res = await fetch(`${API_BASE}/booksession/approve`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: req.id, user_id: req.user_id }), // FIX: include user_id
      });
      const data = await res.json();
      if (data.status) fetchMentorRequests();
      else alert(data.message);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingId(null);
    }
  };

  // Decline
  const declineMentorRequest = async (req) => {
    setLoadingId(req.id);
    try {
      const res = await fetch(`${API_BASE}/booksession/decline`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: req.id, user_id: req.user_id }), // FIX: include user_id
      });
      const data = await res.json();
      if (data.status) fetchMentorRequests();
      else alert(data.message);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingId(null);
    }
  };

  // Search handler
  useEffect(() => {
    if (!search.trim()) {
      setFilteredMentorRequests(mentorRequests);
    } else {
      setFilteredMentorRequests(
        mentorRequests.filter((req) =>
          req.full_name.toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  }, [search, mentorRequests]);

  return (
    <div>
      {/* Search */}
      <input
        type="text"
        placeholder="Search mentor requests..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="border rounded w-full p-2 mb-4"
      />

      {/* Mentor Requests List */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredMentorRequests.map((req) => (
          <div
            key={req.id}
            className="border rounded p-4 bg-white shadow-sm flex flex-col justify-between"
          >
            <div>
              <h3 className="font-semibold text-lg">{req.full_name}</h3>
              <p className="text-gray-500 text-sm">{req.email}</p>
              <p className="text-sm mt-1">
                Date: {req.date} | Time: {req.time_slot || req.time || "N/A"}
              </p>
              <span
                className={`inline-block mt-2 text-xs px-2 py-1 rounded ${
                  req.is_approved === "1"
                    ? "bg-green-100 text-green-700"
                    : req.is_approved === "2"
                    ? "bg-red-100 text-red-700"
                    : "bg-yellow-100 text-yellow-700"
                }`}
              >
                {req.is_approved === "1"
                  ? "Approved"
                  : req.is_approved === "2"
                  ? "Rejected"
                  : "Pending"}
              </span>
            </div>

            {/* Actions */}
            <div className="flex justify-between items-center mt-4">
              <button
                onClick={() => {
                  setSelectedItem(req);
                  setIsModalOpen(true);
                }}
                className="text-blue-600 hover:underline"
              >
                Quick View
              </button>
              <div className="flex gap-2">
                {req.is_approved !== "1" && (
                  <button
                    onClick={() => approveMentorRequest(req)}
                    disabled={loadingId === req.id}
                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600 disabled:opacity-50"
                  >
                    Approve
                  </button>
                )}
                {req.is_approved !== "2" && (
                  <button
                    onClick={() => declineMentorRequest(req)}
                    disabled={loadingId === req.id}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 disabled:opacity-50"
                  >
                    Decline
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick View Modal */}
      {isModalOpen && selectedItem && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded p-6 w-full max-w-md shadow-lg relative">
            <h3 className="text-lg font-semibold mb-2">{selectedItem.full_name}</h3>
            <p className="text-gray-500 mb-2">{selectedItem.email}</p>
            <p className="text-sm mb-2"><strong>Purpose:</strong> {selectedItem.purpose}</p>
            <p className="text-sm mb-2"><strong>Date:</strong> {selectedItem.date}</p>
            <p className="text-sm mb-4">
              <strong>Time:</strong> {selectedItem.time_slot || selectedItem.time || "N/A"}
            </p>
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MentorRequests;
